import { AbstractOperationMessage } from "./abstractOperationMessage"

export class ConfDeleteMessage extends AbstractOperationMessage {
}